<template>
    <div>
        <modal ref="modal">
            <div class="d-block text-center" slot="title" v-if="!form.block">Add New Group</div>
            <div class="animated animated-normal fadeIn" :key="key">
                <div class="row">
                    <div class="col">
                        <input-text label="Name" placeholder="Name" v-model="form.name" :form="form"
                                    field="name"></input-text>
                    </div>
                </div>
            </div>
            <div class="form-group" :class="{'is-invalid': form.errors.has('locations')}">
                <label>Location(s)</label>

                <multiselect
                        v-model="form.locations"
                        placeholder="Search or add a location"
                        track-by="id"
                        label="name"
                        :options="locations"
                        :multiple="true">
                </multiselect>
                <p class="invalid-feedback" v-if="form && form.errors.has('locations')">
                    {{ form.errors.get('locations') }}
                </p>
            </div>
            <div slot="footer">
                <button-loading class="btn btn-primary ml-1" type="button" :loading="form.submitting"
                                @click="saveGroup">Save
                </button-loading>
            </div>
        </modal>
    </div>
</template>

<script>
    import Form from "../../utils/Form";

    export default {
        data() {
            return {
                key      : null,
                locations: [],
                form     : new Form({}),
            };
        },

        created() {
            window.Bus.$on('openAddNewGroupModal', (data) => {
                this.$refs.modal.open();
                this.setupForm();
                this.form.block = data;
                this.key        = Math.random().toString(36);
            });

            this.fetchLocations();
        },

        methods: {
            setupForm() {
                this.form = new Form({
                    name     : null,
                    locations: null,
                });
            },

            saveGroup() {
                this.form.post('/groups')
                    .then(() => {
                        this.$refs.modal.close()

                        Bus.$emit('LoadGroupList');
                        const message = 'New Group Added';
                        this.$alert({message, type: 'success', title: 'Success!'});
                    })
                    .catch(({data}) => {
                        swal.fire({
                            title: data.title,
                            text : data.message,
                            type : 'error',
                        })
                    });
            },

            fetchLocations() {
                return this.$http.get(this.$laroute.route('api.global-filters.location', {'hide': 'campaigns'}))
                    .then(({data}) => {
                        this.locations = data.data;
                    });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .is-invalid {
        .invalid-feedback {
            display: block;
        }
    }
</style>
